import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Button, InfoModal, Text } from '@clutter/clean';

export const MovingRedirectDialog: React.FC = () => {
  const { state } = useLocation<{ from?: string }>();
  const [open, setOpen] = useState<boolean>(true);

  if (state?.from !== 'moving') return null;

  const onToggle = () => {
    setOpen((open) => !open);
  };

  return (
    <InfoModal isOpen={open} handleModalClose={onToggle}>
      <Box.Flex flexDirection="column" gap="16px">
        <Text.Title size="medium">
          Clutter no longer offers traditional moving services.
        </Text.Title>
        <Text.Body>
          Please consider our storage services which can help you store in
          between moving homes or after your move.
        </Text.Body>
        <Button kind="secondary" fullWidth onClick={onToggle}>
          Continue
        </Button>
      </Box.Flex>
    </InfoModal>
  );
};
